import './videos.scss';

import * as React from 'react';
import { graphql } from 'gatsby';
import { sortBy } from 'lodash';

import * as Core from 'components/core';
import Layout from 'components/Layout';
import ContentWrapper from 'components/ContentWrapper';

import { Video as VideoType } from 'components/videos/types';
import Video from 'components/videos/Video';
import VideoGrid from 'components/videos/VideoGrid';
import Masthead from 'components/Masthead';

type Props = {
  data: {
    videos: {
      nodes: VideoType[];
    };
  };
};

export default function VideosPage(props: Props) {
  const videos = sortBy(props.data.videos.nodes, (video) => !video.featured);

  return (
    <Layout title="Video Archive">
      <ContentWrapper>
        <Masthead title="Video Archive">
          <div className="VideosPage-description">
            <Core.LargeBodyText>
              Conference talks from eight years of XOXO.
            </Core.LargeBodyText>
          </div>
        </Masthead>

        <VideoGrid>
          {videos.map((video) => (
            <Video video={video} key={video.id} />
          ))}
        </VideoGrid>
      </ContentWrapper>
    </Layout>
  );
}

export const query = graphql`
  query VideosPageQuery {
    videos: allVideo(sort: { year: DESC }) {
      nodes {
        id
        title
        subtitle
        slug
        year
        src
        tags
        featured
      }
    }
  }
`;
